"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _LinkButton = _interopRequireDefault(require("../Link/LinkButton"));

var _LogoImage = _interopRequireDefault(require("../LogoImage/LogoImage"));

var _linkedin = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/linkedin-1"));

var _facebook = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/facebook-1"));

var _twitter = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/twitter-1"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledMemberInfoBanner = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "MemberInfoBanner__StyledMemberInfoBanner",
  componentId: "koxf94-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    display:flex;\n    flex-direction: row;\n    align-items: flex-start;\n"])));

var StyledIssuerLogoWrapper = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "MemberInfoBanner__StyledIssuerLogoWrapper",
  componentId: "koxf94-1"
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    margin: 0px 14px 0px 0px;\n    \n    img {\n        width: 130px;\n        height: 130px;\n        padding: 13px;\n        border: 1px solid ", ";\n    }\n"])), _Colors.alto);

var StyledMemberInfo = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "MemberInfoBanner__StyledMemberInfo",
  componentId: "koxf94-2"
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: 13px;\n    color: ", ";\n    word-break: break-word;\n"])), _Colors.mineShaft);

var StyledBannerText = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "MemberInfoBanner__StyledBannerText",
  componentId: "koxf94-3"
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    color: ", ";\n    line-height: 13px;\n    margin-top: 9px;\n    font-size: 16px;\n"])), _Colors.emperor);

var StyledIssuerName = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "MemberInfoBanner__StyledIssuerName",
  componentId: "koxf94-4"
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 17px;\n    text-transform: capitalize;\n    margin-top: 14px;\n    margin-bottom: 5px;\n"])));

var StyledIssuerAddress = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "MemberInfoBanner__StyledIssuerAddress",
  componentId: "koxf94-5"
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: 13px;\n    line-height: 14px;\n    font-weight: 600;\n"])));

var StyledMemberLinks = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "MemberInfoBanner__StyledMemberLinks",
  componentId: "koxf94-6"
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    .organization-link {\n        font-size: 13px;\n        height: 30px;\n        min-height: 30px;\n        margin: 15px 20px 0px 0px;\n    }\n"])));

var StyledSocialMediaLinks = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "MemberInfoBanner__StyledSocialMediaLinks",
  componentId: "koxf94-7"
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    max-width: 105px;\n    \n    .linkedin-url, .facebook-url, .twitter-url {\n        font-size: 13px;\n        padding: 7.5px;\n        margin-top: 15px;\n    }\n"])));

var MemberInfoBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MemberInfoBanner, _React$Component);

  var _super = _createSuper(MemberInfoBanner);

  function MemberInfoBanner() {
    (0, _classCallCheck2.default)(this, MemberInfoBanner);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MemberInfoBanner, [{
    key: "escapeHtml",
    value: function escapeHtml(text) {
      return {
        __html: text
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          member = _this$props.member,
          memberLogoUrl = _this$props.memberLogoUrl,
          bannerText = _this$props.bannerText,
          organizationUrl = _this$props.organizationUrl,
          socialMediaLinks = _this$props.socialMediaLinks;
      var address = member.address;
      return /*#__PURE__*/_react.default.createElement(StyledMemberInfoBanner, {
        className: "member-info-banner ".concat(className)
      }, /*#__PURE__*/_react.default.createElement(StyledIssuerLogoWrapper, {
        className: "issuer-logo-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LogoImage.default, {
        member: member,
        memberLogoUrl: memberLogoUrl
      })), /*#__PURE__*/_react.default.createElement(StyledMemberInfo, null, /*#__PURE__*/_react.default.createElement(StyledBannerText, {
        className: "banner-text"
      }, bannerText), /*#__PURE__*/_react.default.createElement(StyledIssuerName, {
        className: "issuer-name",
        dangerouslySetInnerHTML: this.escapeHtml(member.name)
      }), /*#__PURE__*/_react.default.createElement(StyledIssuerAddress, {
        className: "issuer-address"
      }, /*#__PURE__*/_react.default.createElement("div", null, "".concat(address.city, ", ").concat(address.state)), /*#__PURE__*/_react.default.createElement("div", null, address.country)), /*#__PURE__*/_react.default.createElement(StyledMemberLinks, null, organizationUrl && organizationUrl.trim().length > 0 && /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        href: organizationUrl,
        label: "Organization Website",
        className: "organization-link"
      }), /*#__PURE__*/_react.default.createElement(StyledSocialMediaLinks, null, socialMediaLinks.linkedInUrl && socialMediaLinks.linkedInUrl.trim().length > 0 && /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        href: socialMediaLinks.linkedInUrl,
        label: /*#__PURE__*/_react.default.createElement(_linkedin.default, {
          noPad: true
        }),
        className: "linkedin-url",
        round: true
      }), socialMediaLinks.facebookUrl && socialMediaLinks.facebookUrl.trim().length > 0 && /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        href: socialMediaLinks.facebookUrl,
        label: /*#__PURE__*/_react.default.createElement(_facebook.default, {
          noPad: true
        }),
        className: "facebook-url",
        round: true
      }), socialMediaLinks.twitterUrl && socialMediaLinks.twitterUrl.trim().length > 0 && /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
        href: socialMediaLinks.twitterUrl,
        label: /*#__PURE__*/_react.default.createElement(_twitter.default, {
          noPad: true
        }),
        className: "twitter-url",
        round: true
      })))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        className: _propTypes.default.string,
        member: _propTypes.default.shape({
          id: _propTypes.default.number.isRequired,
          name: _propTypes.default.string.isRequired,
          address: _propTypes.default.shape({
            city: _propTypes.default.string.isRequired,
            state: _propTypes.default.string.isRequired,
            country: _propTypes.default.string.isRequired
          }).isRequired
        }),
        bannerText: _propTypes.default.string,
        memberLogoUrl: _propTypes.default.string.isRequired,
        organizationUrl: _propTypes.default.string,
        socialMediaLinks: _propTypes.default.shape({
          linkedInUrl: _propTypes.default.string,
          facebookUrl: _propTypes.default.string,
          twitterUrl: _propTypes.default.string
        })
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        className: '',
        bannerText: 'ISSUED BY',
        socialMediaLinks: {
          linkedInUrl: '',
          facebookUrl: '',
          twitterUrl: ''
        }
      };
    }
  }]);
  return MemberInfoBanner;
}(_react.default.Component);

exports.default = MemberInfoBanner;